import { InputFormControl, InputFormControlProps } from './InputFormControl'

export type InputPercentageFormControlProps = InputFormControlProps

export const InputPercentageFormControl = ({
  control,
  formControlName,
  ...props
}: InputPercentageFormControlProps) => (
  <InputFormControl
    control={control}
    formControlName={formControlName}
    type="number"
    min={0}
    max={100}
    suffix="%"
    {...props}
  />
)
